package com.macrofocus.high_d.axis.group

import com.macrofocus.high_d.axis.AxisListener

abstract class AbstractAxisGroupModel<R, C> : AxisGroupModel<R, C> {
    private val listeners: MutableList<AxisListener> = ArrayList<AxisListener>()
    override fun addAxisListener(listener: AxisListener) {
        listeners.add(listener)
    }

    override fun removeAxisListener(listener: AxisListener) {
        listeners.remove(listener)
    }

    fun fireAxisChanged() {
        for (listener in listeners) {
            listener.axisChanged()
        }
    }
}